
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useBridgeOperations = (refreshData: () => Promise<void>) => {
  const handleAddBridgeItem = async (name: string, value: number, description: string) => {
    try {
      const { data: { user }, error: userError } = await supabase.auth.getUser();
      if (userError) {
        throw userError;
      }
      
      const {
        data,
        error: fetchError
      } = await supabase.from("bridgeplan").select("SN").order("SN", {
        ascending: false
      }).limit(1);
      if (fetchError) throw fetchError;
      const nextSN = data && data.length > 0 ? data[0].SN + 1 : 1;
      
      const {
        data: newItem,
        error: insertError
      } = await supabase.from("bridgeplan").insert({
        bridge_component: name,
        bridge_value: value,
        bridge_description: description,
        SN: nextSN,
        user_id: user?.id
      }).select().single();
      
      if (insertError) throw insertError;
      
      await refreshData();
      toast.success("Bridge component added successfully");
    } catch (error) {
      console.error("Error adding bridge item:", error);
      toast.error("Failed to add bridge component");
      throw error;
    }
  };

  const handleEditBridgeItem = async (id: string, name: string, value: number, description: string) => {
    try {
      const { data: { user }, error: userError } = await supabase.auth.getUser();
      if (userError) {
        throw userError;
      }
      
      const {
        error
      } = await supabase.from("bridgeplan").update({
        bridge_component: name,
        bridge_value: value,
        bridge_description: description,
        user_id: user?.id
      }).eq("id", id);
      
      if (error) throw error;
      
      await refreshData();
      toast.success("Bridge component updated successfully");
    } catch (error) {
      console.error("Error updating bridge item:", error);
      toast.error("Failed to update bridge component");
      throw error;
    }
  };

  const handleDeleteBridgeItem = async (itemId: string) => {
    try {
      const {
        error
      } = await supabase.from("bridgeplan").delete().eq("id", itemId);
      if (error) throw error;
      
      await refreshData();
      toast.success("Bridge component deleted successfully");
    } catch (error) {
      console.error("Error deleting bridge item:", error);
      toast.error("Failed to delete bridge component");
      throw error;
    }
  };

  return {
    handleAddBridgeItem,
    handleEditBridgeItem,
    handleDeleteBridgeItem
  };
};
